<div class="full-screen-dialog analytics">
  <button class="floating-close-button" [mat-dialog-close]>
    <svg-icon-sprite style="color:white;" [src]="'assets/images/svgIconsSprite.svg#cross'" [width]="'24px'">
    </svg-icon-sprite>
  </button>
  <h1 mat-dialog-title>Results {{getNodeName(journeyData.node_type)?'for':''}}
    {{getNodeName(journeyData.node_type)}}</h1>
  <mat-dialog-content class="scrollable-container">
    <p *ngIf="getNodeName(journeyData.node_type) === 'Branch' && showBranchId" class="branch-id">
      ID {{journeyData.journey_hash}}{{journeyData.branches[0].branch_id}}
    </p>
    <div class="analytics-container">
      <div class="row event-selector">
        <div class="col-md-3">
          <mat-form-field [floatLabel]="'always'" appearance="outline">
            <mat-label> Showing Event </mat-label>
            <mat-select [(ngModel)]="selectedEvent" (ngModelChange)="onEventChange()">
              <mat-select-trigger class="small-icon">
                <mat-icon style="width: 16px; font-size: 1em;" *ngIf="selectedEvent.primary">flag</mat-icon>
                {{selectedEvent.name}}
              </mat-select-trigger>
              <mat-option *ngFor="let event of journeyData.events" [value]="event">
                <mat-icon style="width: 16px; font-size: 1em;" *ngIf="event.primary">flag</mat-icon> {{event.name}}

                <span class="event-props"
                  *ngIf="event && event.criteria && event.criteria.rules && event.criteria.rules.length && ifAnyPropValueExist(event.criteria.rules)">
                  <ng-container *ngFor="let evRule of event.criteria.rules; let i=index;">
                    {{evRule.field}}{{ i === (event.criteria.rules.length - 1) ? ' ' : ',' }}
                  </ng-container>
                </span>

              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3"
          *ngIf="selectedEvent && selectedEvent.criteria && selectedEvent.criteria.rules && selectedEvent.criteria.rules.length && ifAnyPropValueExist(selectedEvent.criteria.rules)">
          <p class="event-type">Event Type</p>
          <p class="event-criteria text-truncate">
            {{selectedEvent.type && selectedEvent.type.label?selectedEvent.type.label:''
            }} &nbsp;
          </p>
        </div>

        <div class="col-md-6"
          *ngIf="selectedEvent && selectedEvent.criteria && selectedEvent.criteria.rules && selectedEvent.criteria.rules.length && ifAnyPropValueExist(selectedEvent.criteria.rules)">
          <p class="event-type">Event Properties</p>
          <p class="event-criteria text-truncate">
            <ng-container *ngFor="let rule of selectedEvent.criteria.rules; let i=index;">
              <ng-container *ngIf="rule.value">
                {{rule.field || rule.id}} = {{rule.value}}
                <ng-container *ngIf="i !== (selectedEvent.criteria.rules.length - 1)">,
                </ng-container>
              </ng-container>
            </ng-container>
            &nbsp;
          </p>
        </div>

      </div>
      <div class="row analytics-graph">
        <!-- <div class="col-md-6">
          <div *ngIf="!chartLoading && showDataReloadBtn()">
            <svg-icon-sprite style="color:#1485c6;" [src]="'assets/images/svgIconsSprite.svg#graph-refresh'"
              [width]="'24px'" (click)="reloadAnalyticsData()"></svg-icon-sprite>
            <br>
            <i>Last update {{ getFormattedTS() }}.
              <a (click)="reloadAnalyticsData()" style="cursor:pointer">Click to refresh</a>
            </i>
          </div>
          <div *ngIf="!chartLoading && !showDataReloadBtn()">
            The chart data is already scheduled for update.
          </div>
        </div> -->
        <div class="col-md-6 chart-tooling">
          <mat-form-field [floatLabel]="'always'" appearance="outline">
            <mat-label> Graph report of </mat-label>
            <mat-select [(ngModel)]="selectedTimeOption" (ngModelChange)="onTimeOptionChange()">
              <mat-option *ngFor="let timeOption of reportTimeOptions" [value]="timeOption">{{timeOption.text}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-slide-toggle class="normalize-toggle" [(ngModel)]="normalizeData" (change)="onNormalizationChange()">
            Normalize <br /> Data
          </mat-slide-toggle>
        </div>
        <div class="col-md-12">
          <div class="chart-container" *ngIf="!chartLoading">
            <canvas baseChart [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
              [colors]="lineChartColors" [legend]="true" [chartType]="'line'"></canvas>
          </div>
          <div class="animate-flicker" *ngIf="chartLoading" style="position: relative; height: 400px">
            <div class="align-absolute-center">
              <img src="/assets/images/Loader-PX.svg" class="px-loader">
            </div>
          </div>
        </div>
      </div>
      <div class="row analytics-table">
        <div class="col-md-12">
          <table *ngIf="resultTableData.length && !resultTableDataLoading" mat-table [dataSource]="dataSource">

            <!-- Branch Column -->
            <ng-container matColumnDef="branch">
              <th mat-header-cell *matHeaderCellDef> Variants / Branches </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="getNodeName(journeyData.node_type) === 'Branch'">
                  <ng-container *ngIf="showBranchId">{{branchIdBranchNameMap[element.branch_id]}} (ID
                    {{journeyData.journey_hash}}{{element.branch_id}})</ng-container>
                  <ng-container *ngIf="!showBranchId">{{branchIdBranchNameMap[element.branch_id]}}</ng-container>
                </ng-container>
                <ng-container *ngIf="getNodeName(journeyData.node_type) !== 'Branch'">
                  {{branchIdBranchNameMap[element.branch_id]}}</ng-container>
              </td>
            </ng-container>

            <!-- Event Count Column -->
            <ng-container matColumnDef="event_count">
              <th mat-header-cell *matHeaderCellDef> Event count for {{selectedEvent.name}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.tc}}
              </td>
            </ng-container>

            <!-- Converted Users Column -->
            <ng-container matColumnDef="conversions">
              <th mat-header-cell *matHeaderCellDef> Converted Users </th>
              <td mat-cell *matCellDef="let element">
                {{element.uc}}
              </td>
            </ng-container>

            <!-- Revenue Count Column -->
            <ng-container matColumnDef="total_revenue">
              <th mat-header-cell *matHeaderCellDef> Revenue </th>
              <td mat-cell *matCellDef="let element">
                {{element.sum}}
              </td>
            </ng-container>

            <!-- Sum Count Column -->
            <ng-container matColumnDef="sum">
              <th mat-header-cell *matHeaderCellDef> Sum </th>
              <td mat-cell *matCellDef="let element">
                {{element.sum}}
              </td>
            </ng-container>

            <!-- Total Unique Users Column -->
            <ng-container matColumnDef="unique_user_count">
              <th mat-header-cell *matHeaderCellDef> Total Users </th>
              <td mat-cell *matCellDef="let element">
                {{element.uuc}}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
          </table>
          <div class="animate-flicker" *ngIf="resultTableDataLoading" style="position: relative; height: 400px;">
            <div class="align-absolute-center">
              <img src="/assets/images/Loader-PX.svg" class="px-loader">
            </div>
          </div>
        </div>
      </div>
      <div class="row ab-container"
        *ngIf="(journeyData.node_type === 'ab_exp_node') && (journeyData.branches.length > 1)">
        <div class="col-md-12" *ngIf="endAbTest.step1">
          <!-- <p class="user-text">Users in the A/B experiment</p> -->
          <!-- <mat-slider thumbLabel class="slider" [max]="100" [min]="0" [(ngModel)]="endAbTest.rollout_percent"></mat-slider> -->
          <div>
            <button class="primary-btn" mat-flat-button (click)="endAbTest.step1 = false">END A/B TEST</button>
          </div>
        </div>
        <div class="col-md-12" *ngIf="!endAbTest.step1">
          <p class="user-text-bold">End the A/B Test</p>
          <div class="col-md-12 pl-0">
            <mat-form-field class="medium">
              <mat-select placeholder="Choose a winning variant to finish the A/B"
                [(ngModel)]="endAbTest.winning_variant">
                <ng-container *ngFor="let item of splitPercList; let i = index">
                  <mat-option [value]="i" *ngIf="i !== 0">
                    {{ i === 0 ? 'Default' : 'Variant'+ i}}
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-12 pl-0" *ngIf="endAbTest.winning_variant">
            <p class="user-text">Percentage of users to roll out winning variant to</p>
            <mat-slider thumbLabel class="slider" [max]="100" [min]="0" [(ngModel)]="endAbTest.rollout_percent">
            </mat-slider>
          </div>
          <div class="col-md-12 pl-0">
            <button class="primary-btn" mat-flat-button
              [disabled]="!endAbTest.winning_variant || !endAbTest.rollout_percent" (click)="finishExperiment()">FINISH
              EXPERIMENT</button>
            <button class="secondary-btn" style="margin-left: 16px" mat-flat-button
              (click)="endAbTest.step1 = true; endAbTest.winning_variant = ''; endAbTest.rollout_percent = journeyData.rollout_percent">CANCEL</button>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-note" *ngIf="!resultTableDataLoading">
      Note: Results might take up to one hour to be in sync
    </div>

  </mat-dialog-content>

</div>
